import React from 'react';
import './index.css';

const Spin = (props: any) => (
  <div className='showbox'>
    <div className='loader' style={{ width: props.width ? props.width : '45px' }}>
      <svg className='circular' viewBox='25 25 50 50'>
        <circle className='path' cx='50' cy='50' r='20' fill='none' strokeWidth='2' strokeMiterlimit='10' />
      </svg>
    </div>
    {props.message && <small>{props.message}</small>}
  </div>
);
export default Spin;
